module.exports = __webpack_public_path__ + "img/dots.60a24ce4.svg";